module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-27.2df5f7e1.png";